'use client'

import { X } from 'lucide-react'
import { useState } from 'react'

const DeliveryNotAvailable = () => {
  const [show, setShow] = useState(true)

  if (!show) return null

  return (
    <div className='delivery-not-available'>
      <button className='delivery-not-available__close' onClick={() => setShow(false)} aria-label='Cerrar'>
        <X size={18} />
      </button>
      <p className='delivery-not-available__text'>
        Lo sentimos, no estamos aceptando pedidos en este momento. Prueba de nuevo más tarde.
      </p>
    </div>
  )
}
export default DeliveryNotAvailable
